import React from 'react';
import NavigationMenuSection from "../../../menu-items/section/section";
import NavigationMenuItemCustomView from "../../../menu-items/custom-view/menu-item-custom-view";
import NavigationMenu_ProjectsLocalSettings from "../../../local-settings";
import ArrayUtils from "../../../../../core/gd/utils/array";
import mainMenu_homeViews from "../../../actions/home-views";
import ProjectCollectionModel from "../../../../../core/model2/project-collection/project-collection-model";
import CustomView from "../../../../../core/model2/custom-view/custom-view";
import {EntityType} from "../../../../../core/gd/const/item";
import NavigationMenuItemPortfolio from "../../../menu-items/portfolio/menu-item-portfolio";
import {EVENT_BUS_SESSION_PORTFOLIO_CHANGED} from "../../../../../core/model2/project-collection/events";
import NavigationMenu_NewView from "../../../menu-items/menu-new-view/menu-new-view";
import {NavigationSectionType} from "../../../../../core/model2/navigation/@const"
import {EVENT_BUS_MENU_RERENDER} from "../../const";
import MainMenu_SectionReorderableWithMore from "../../../components/menu-controller/menu-section-reordable-with-more";

export default class MainMenu_HomeCustomViews extends React.Component<any,any> {

    public localSettings    : NavigationMenu_ProjectsLocalSettings

    constructor(props:any) {
        super(props);

        this.localSettings = new NavigationMenu_ProjectsLocalSettings()
    }

    componentDidMount() {
        gd.bus.subscribe('gd.session.customViews:change', this, this.update);
        gd.bus.subscribe(EVENT_BUS_SESSION_PORTFOLIO_CHANGED, this, this.update);
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this);
    }

    update = () => {
        this.forceUpdate()
    }

    sessionDataChanged = () => {
        this.forceUpdate()
    }

    onReorderEnd = (items:any) => {
        gd.user.settings.menu.homeCustomViews.sortPositions = items.map((item:any)=>item.id);
        gd.user.settings.menu.save();
    }

    toggleMore = ()=>{
        const showMore = gd.user.settings.menu.homeCustomViews.showMore;
        gd.user.settings.menu.homeCustomViews.showMore = !showMore;
        gd.user.settings.menu.save();

        gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)
    }

    render() {
        const components : any[] = []

        const allItems : CustomView[] | ProjectCollectionModel[] = mainMenu_homeViews()

        // @ts-ignore
        _.map(allItems, (menuItem:CustomView|ProjectCollectionModel) => {
            switch (menuItem.entityType) {
                case EntityType.PORTFOLIO:
                    components.push({
                        item:       menuItem,
                        component:  <NavigationMenuItemPortfolio portfolio={menuItem as ProjectCollectionModel} navigationSection={this.props.navigationSection} />
                    })
                    break

                case EntityType.CUSTOM_VIEW:
                default:
                    components.push({
                        item:       menuItem,
                        component:  <NavigationMenuItemCustomView viewId={menuItem.id} navigationSection={this.props.navigationSection} />
                    })
                    break;
            }
        })

        const menuItems = _(components)
            .orderBy([
                component=>ArrayUtils.indexOrder(gd.user.settings.menu.homeCustomViews.sortPositions, component.item.id), // try to order by sort position
            ], ['asc'])
            .value();

        return (
            <NavigationMenuSection name         = "Views"
                                   collapsible  = {true}
                                   systemName   = "homeCustomViews"
                                   counter      = {components.length}>

                <MainMenu_SectionReorderableWithMore countVisibleItems   = {5}
                                                     moreTitle           = "All Views"
                                                     components          = {menuItems}
                                                     settingsKey         = "home-custom-view-items"
                                                     onReorderEnd        = {this.onReorderEnd}/>

                <NavigationMenu_NewView selectedGroupId          = 'tasks'
                                       navigationSectionType    = {NavigationSectionType.HOME}/>
                {/*<NavigationMenuAdd label="New dashboard" onClick={this.onAddDashbaordClick}/>*/}
            </NavigationMenuSection>
        );
    }
}
